<!-- role="status" so assistive tech announces the failure when it replaces the
     skeleton, without stealing focus the way role="alert" would. -->
<div class="rak-error-state" role="status" aria-live="polite">
  <p class="rak-error-state__text">{{ text }}</p>
  <button
    *ngIf="showRetry"
    type="button"
    class="rak-error-state__retry"
    (click)="onRetry()"
  >{{ retryText }}</button>
</div>
